module.exports = __webpack_public_path__ + "resources/img/img_intermax_4_m.2ad45785e4901fd7f2d9dce94fad821d.png";